import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circular',
  templateUrl: './circular.component.html',
  styleUrls: ['./circular.component.css']
})
export class CircularComponent implements OnInit {

    public happyText = 'Text coming from .ts file';
    
    public myTodos = [
        'coffee mug',
        'Spoon',
        'A/C',
        'Dish'
    ];
    
  constructor() { }

  ngOnInit() {
  this.happyText = 'This text is coming from ngOnInit()';
  }
  
  changeText(){
    this.happyText = 'This text changes after click event';
   }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/circular/circular.component.ts